<div class="top-margin-15"></div>
<div class="row nova-font-style">
  <div class="col s12 m12 l12 xl12 remove-default-padding">
    <div [hidden]="initialLoading">
      <div>
        <kendo-tabstrip #trackertabstrip [animate]="true" [tabAlignment]="'justify'" id="tracker-tab">
          <kendo-tabstrip-tab title="Active" [selected]="true">
            <ng-template kendoTabContent>
              <app-active-task></app-active-task>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Completed" class="right-margin-0">
            <ng-template kendoTabContent>
              <app-completed-task></app-completed-task>
            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>
    </div>
  </div>
</div>
